import {FC, SVGProps} from 'react';

export const RegistrationSuccessIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="153" height="200" viewBox="0 0 153 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M20.8108 99.3245C20.8108 93.6666 20.7267 90.7325 20.8108 86.6205C21.5575 48.9399 39.7616 21.618 75.402 2.20447C80.1976 -0.403623 86.2025 1.36316 88.8106 6.15869C91.4187 10.9542 89.6519 16.9592 84.8564 19.5672"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path
			d="M76.7282 183.54V167.639C84.216 173.592 93.8807 177.02 103.955 177.388C116.06 177.84 127.523 173.844 136.262 166.157C145.296 158.206 150.512 147.027 150.975 134.681C151.175 129.212 146.915 124.616 141.447 124.417C135.978 124.217 131.383 128.476 131.183 133.944C130.667 147.963 119.362 158.132 104.776 157.596C90.2314 157.06 80.8192 146.322 81.345 132.072V111.66C81.8603 97.6415 93.2602 87.472 107.836 88.0083C122.38 88.5447 132.55 99.282 132.024 113.532C131.824 119 136.083 123.596 141.552 123.796C147.021 123.996 151.616 119.737 151.816 114.268C152.268 101.932 147.999 90.4166 139.785 81.8667C131.761 73.5166 120.677 68.6685 108.572 68.2163C96.4677 67.7641 85.0047 71.7603 76.2655 79.4479C70.3026 84.6956 64.2977 91.4472 62.8149 99.3241C58.114 65.1769 77.1384 39.5903 107.342 32.2077C112.642 30.9142 115.892 25.5613 114.598 20.2609C113.305 14.9606 107.952 11.711 102.651 13.0046C68.1994 21.4283 42.2656 50.6537 42.2656 84.1698V99.3241"
			stroke="black"
			strokeWidth="2"
			strokeLinejoin="bevel"
		/>
		<path
			d="M1 104.866V16.5594C1 11.1013 5.42745 6.67383 10.8855 6.67383C16.3436 6.67383 20.771 11.1013 20.771 16.5594L20.8236 93.8347"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path d="M1 99.3457V181.595" stroke="black" strokeWidth="2" strokeMiterlimit="10" />
		<path d="M1 181.984L1 199H76.7294V181.984H1Z" fill="black" stroke="black" strokeWidth="2" strokeMiterlimit="10" />
	</svg>
);
